export const FamigrosTheme = {
  name: 'Famigros Theme',
  themeId: 'famigros',
  colors: {
    brand: {
      primary: {
        100: '#f39149'
      },
      secondary: {
        100: '#ff6600'
      },
      accent: {
        100: '#f39149'
      },
      highlight: {
        100: '#f39149'
      },
      altHighlight: {
        100: '#ff6600'
      }
    },
    tints: {
      gray: {
        5: '#FAFAFA',
        10: '#F5F5F5',
        30: '#F2F2F2',
        40: '#EDEDED',
        50: '#D7D7D7',
        60: '#ADADAD',
        75: '#888888',
        80: '#525252',
        90: '#262D31',
        100: '#555'
      },
      black: {
        90: '#000000ad'
      }
    }
  },
  backgrounds: {
    tile: '#F2F2F2'
  },
  fonts: {
    families: {
      text: '"HelveticaNeueW01-55Roma", helvetica, sans-serif',
      condensed: '"Yuzu W00 Bold", sans-serif',
      notes: '"Yuzu W00 Medium", sans-serif',
      heading: '"Yuzu W00 Bold", sans-serif',
      subHeading: '"Yuzu W00 Bold", sans-serif',
      display: '"Yuzu W00 Bold", sans-serif',
      articleText: '"HelveticaNeueW01-55Roma", helvetica, sans-serif',
      articleHeading: '"Yuzu W00 Bold", sans-serif',
      articlePrice: '"Yuzu W00 Bold", sans-serif'
    },
    weights: {
      thin: 300,
      light: 300,
      regular: 400,
      medium: 400,
      semiBold: 400,
      bold: 400,
      bolder: 400
    },
    sizes: {
      heading: {
        tiny: '18px',
        xtiny: '19px',
        xsmall: '20px',
        modest: '22px',
        small: '24px',
        medium: '28px',
        large: '30px',
        xlarge: '36px',
        huge: '40px'
      }
    }
  }
};